import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import { ExternalPaths, Paths } from '@shared/menu-items/paths'
import cx from 'classnames'
import Link from 'next/link'

import styles from './style.module.scss'

export const View = () => (
	<Section className={styles.wrapper}>
		<div className={styles.openness}>
			<h3 className={styles.title}>Открытость</h3>
			<div className={styles.opennessContent}>
				<h4 className={styles.subheading}>
					Мы уверены, что прозрачность — сильное преимущество передовых компаний. Поэтому
					поддерживаем публичную открытость, делимся новостями и отчётами.
				</h4>
				<div className={styles.document}>
					<Image name='document-icon.png' />
					Устав
				</div>
				<div className={styles.document}>
					<Image name='document-icon.png' />
					Положение о собрании акционеров
				</div>
				<Link href={Paths.documents} className={cx(styles.link, 'main-link')}>
					Посмотреть все документы
				</Link>
				{/* <div className={styles.chronicle}>
					<h4 className={styles.subtitle}>Летопись</h4>
					<p>
						Каждый квартал мы&nbsp;публикуем обзор о&nbsp;результатах команды. Посмотрите, что
						мы&nbsp;делаем и&nbsp;как работаем.
					</p>
					<a
						href={ExternalPaths.chronicle}
						target='_blank'
						rel='noopener noreferrer nofollow'
						className={cx(styles.link, 'main-link')}
					>
						Узнать, как работают
					</a>
				</div> */}
				{/* <div className={styles.instagram}>
					<h4 className={styles.subtitle}>Жизнь компании</h4>
					<p>
						Знакомим с&nbsp;командой, которая делает простой и&nbsp;удобный сервис для займов
						и&nbsp;инвестиций. Делимся новостями и&nbsp;показываем, как мы&nbsp;живём.
					</p>
				</div> */}
			</div>
		</div>
		<div className={styles.responsibility}>
			<h3>Ответственность</h3>
			<div className={styles.responsibilityContent}>
				<h4 className={styles.responsibilityTitle}>
					Мы понимаем уровень ответственности, который ложится на финансовые сервисы. Поэтому
					следуем всем нормативам и законам, а также содействуем финансовому и экономическому
					развитию России.
				</h4>
				<div className={styles.responsibilityDocuments}>
					<Link href={Paths.documents} className='main-link'>
						Регулирующие документы
					</Link>
				</div>
				<div className={styles.orgs}>
					<div className={styles.org}>
						<div className={styles.logo}>
							<Image name='logo-operators.png' lazy />
						</div>
						<h5 className={styles.orgName}>
							Состоим в Ассоциации операторов инвестиционных платформ
						</h5>
					</div>
				</div>
			</div>
		</div>
	</Section>
)
